<div class="group-item">
    <header (click)="openVersions()">
        <strong class="group-counter">{{related.total}}</strong>
        <core-labels-list [labels]="related.labels"></core-labels-list>
        <span class="arrow-marker" [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}"></span>
    </header>
    <core-versions-related-files-list-checkbox
        [hidden]="!opened"
        [related]="related"
        [selected]="selected"
        (selectedChange)="onChange($event);"
        [disabled]="disabled"
    ></core-versions-related-files-list-checkbox>
</div>
